import React from "react";
import { injectIntl } from "react-intl";

function DistancePin({intl, distance, appConfigs}) {
  if (distance && distance > 0) {
    const distanceMeasure = appConfigs && appConfigs.distance_measure ?
      appConfigs.distance_measure : intl.formatMessage({id: "DistancePin.DistanceMeasure"});
    const distanceText = `${distance} ${distanceMeasure}`
    return (
      <div className="distance-pin">
        <span className="icon icon--inline icon--informative">
          <svg>
            <use xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#marker"/>
          </svg>
        </span>
        <span className="text--alternative">
          {
            distance <= 1 ? `< ${distanceText}` : distanceText
          }
        </span>
      </div>
    );
  }

  return null;
}

export default injectIntl(DistancePin);